// extracted by mini-css-extract-plugin
module.exports = {"small":"Small_small__B42wk","xs":"Small_xs__SqaGj"};